import React from 'react'

import BusinessSection from '@/business-section'
import Button from '@/button'
import ApplySurveyForm from '@/apply-survey-form'

const SectionGotInterested = ({ gray }) => {
  return (
    <BusinessSection
      title="Got interested?"
      subtitle={
        <span>
          Getting started is quick, easy and free.<br /><br />
          Get started in 2 minutes by filling up the contact form. <br/>
          After this, our team will contact you within 24 hours.
        </span>
      }
      gray={gray}
    >
      <div className="tc mb6">
        <Button to="/get_started" color="gold">Get started</Button>
      </div>

      <ApplySurveyForm />
    </BusinessSection>
  )
}

export default SectionGotInterested



// WEBPACK FOOTER //
// ./src/components/section-got-interested/section-got-interested.js